module.exports = __webpack_public_path__ + "media/images/user/instagram-6811c579f06d216c32ea3041a1f87678.svg";